export default {"src":"/_next/static/media/icon.97e25e3e.svg","height":17,"width":17};